import { createSlice, current } from '@reduxjs/toolkit';
import {
	getBreachRecordList,
	getBreachRecord,
	addNewBreachRecord,
	updateBreachRecord,
	deleteBreachRecord,
} from './thunk';

export const initialState = {
	breachRecordList: [],
	isLoadingList: false,
	currentBreachRecord: null,
	isLoadingCurrent: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const BreachRecordSlice = createSlice({
	name: 'BreachRecord',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getBreachRecordList.pending, state => {
			state.isLoadingList = true;
		});

		builder.addCase(getBreachRecordList.fulfilled, (state, action) => {
			state.breachRecordList = action.payload || [];
			state.isLoadingList = false;
		});

		builder.addCase(getBreachRecordList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
		});

		builder.addCase(getBreachRecord.pending, state => {
			state.isLoadingCurrent = true;
			state.currentBreachRecord = null;
		});

		builder.addCase(getBreachRecord.fulfilled, (state, action) => {
			state.currentBreachRecord = action.payload;
			state.isLoadingCurrent = false;
		});

		builder.addCase(getBreachRecord.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingCurrent = false;
		});

		builder.addCase(addNewBreachRecord.pending, state => {
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewBreachRecord.fulfilled, (state, action) => {
			state.breachRecordList.unshift(action.payload);
			state.isAdding = false;
			state.isAdded = true;
		});

		builder.addCase(addNewBreachRecord.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateBreachRecord.pending, state => {
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateBreachRecord.fulfilled, (state, action) => {
			state.breachRecordList = state.breachRecordList.map(item =>
				item._id.toString() === action.payload._id.toString()
					? { ...item, ...action.payload }
					: item
			);
			state.isUpdating = false;
			state.isUpdated = true;
		});

		builder.addCase(updateBreachRecord.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteBreachRecord.pending, state => {
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteBreachRecord.fulfilled, (state, action) => {
			state.breachRecordList = current(state.breachRecordList).filter(
				item => item._id !== action.payload._id
			);
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteBreachRecord.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isDeleting = false;
			state.isDeleteError = true;
		});
	},
});

export const { setRequireCloseModal } = BreachRecordSlice.actions;
export default BreachRecordSlice.reducer;
